import React from 'react';
import PlatformHeatmapList from '../../../components/analytics/heatmapList';

interface BestTimeToPostTabProps {
  platforms?: string[];
}

const BestTimeToPostTab: React.FC<BestTimeToPostTabProps> = ({ platforms }) => {
  return (
    <div>
      <PlatformHeatmapList platforms={platforms} />
    </div>
  );
};

export default BestTimeToPostTab;